var signature = "";
var AccessKey = "efa146311ff59066";
var scanID = "";
var overlaySignature = "";
var retakeStatus = "false";

var check_id = getCookie('vtoscanid');
var check_overlaySignature = getCookie('vtooverlay');

console.log('data', check_id);

if (check_id !== undefined) {
  	let container = document.getElementById("ditto-container");
	setTimeout(function(){ getToken(); }, 200);
            let x = document.getElementsByClassName("left-content");
            x[0].style.display = "none";
            container.style.opacity = 0;
            container.style.visibility = "hidden";
}

document.addEventListener("DOMContentLoaded", function(event) { 
	let container = document.getElementById("ditto-container");
  	let background = document.getElementById("modal-background");
  	container.addEventListener("click", function(){
      container.style.opacity = 0;
      container.style.visibility = "hidden";
    });
  
  	let check_total_var = document.getElementsByName('Color');
      
  
  	var elements = document.getElementsByClassName("one-product");

    var myFunction = function() {
        var attribute = this.getAttribute("data-sku");
//         alert(attribute);
      	const active = document.querySelector('.one-product.active');
        if(active){
          active.classList.remove('active');
        }
      	this.classList.add('active');

    	let sku = this.getAttribute("data-sku");
	    reTakeSignature();
    };

	Array.from(elements).forEach(function(element) {
      element.addEventListener('click', myFunction);
    });
});

function checkVTO(){
  scanID = getCookie('vtoscanid');
  overlaySignature = getCookie('vtooverlay');
  
  if(scanID != undefined && overlaySignature != undefined){
//     console.log('sini', overlaySignature);
    
    let active = document.querySelector('.one-product.active');
    let sku = active.getAttribute("data-sku");
    changeTryOnVariant(sku);
  }else if (scanID != undefined && overlaySignature == undefined){
  	reTakeSignature();
  }else{
  	initDitto();
  }
}

function reTakeSignature () {
  var check_id = getCookie('vtoscanid');
	let active = document.querySelector('.one-product.active');
    var get_id_send = active.getAttribute("data-sku");
  let container = document.getElementById("ditto-container");
  
  $.get("/tools/token/ditto-auth-credentials/?message=" + check_id, function(response) {
    var options = {
  		"tryOnServer":"https://vto.partners-au.api.ditto.com",
  		"domSelector":"#ditto-tryon",
  		"glassesId":get_id_send,
  		"partnerId":"projectsoul",
  		"accessKey":response['X-Ditto-Access-Key-Id'],
  		"scanId":check_id,
  		"overlaySignature":response['X-Ditto-Signature'],
  		"disablePreview":false
    };
    var overlay = new Ditto.Overlay(
      options,
      {
        initialized: function() {
          console.log("initialized");
        },
        success: function() {
          console.log("Success");
            let x = document.getElementsByClassName("left-content");
            x[0].style.display = "none";
            container.style.opacity = 0;
            container.style.visibility = "hidden";
            
            let y = document.getElementById("ditto-tryon");
            y.style.display = "block";
        },
        failure: function() {
          console.log("Failure");
        },
        onclick: function() {
          console.log("Optional Event: Click of VTO");
        }
      }
    );
  });
  
}

function getCookie (name) {
	let value = `; ${document.cookie}`;
	let parts = value.split(`; ${name}=`);
	if (parts.length === 2) return parts.pop().split(';').shift();
}

function initDitto(){
	let active = document.querySelector('.one-product.active');
    var get_id_send = active.getAttribute("data-sku");
//   let container = document.getElementById("ditto-scan");
//   container.classList.remove("active");
  
//   let x = document.getElementsByClassName("first-ditto");
//   x[0].style.display = "none";
  
  let lastElements = document.getElementsByClassName("DittoSandbox");
  while(lastElements.length > 0){
    lastElements[0].parentNode.removeChild(lastElements[0]);
  }
  
  let container = document.getElementById("ditto-container");
  container.style.opacity = 1;
  container.style.visibility = "visible";
 
  var scan = new Ditto.Scan(
  {
    tryOnServer: "https://vto.partners-au.api.ditto.com",
    partnerId: "projectsoul",
    font: "opensans",
    domSelector: "#ditto-container",
    accessKey: AccessKey,
    partnerSignature: signature
  },
  {
    success: function(response) {
      console.log("success", response.scanId);
      scanID = response.scanId;
      overlaySignature = response.overlaySignature;
      let scanContainer = document.getElementById("scan-iframe");
      scanContainer.style.display = "none";
      ga('send', 'event', 'Ditto', 'Success', 'IndexPage');
      
      var overlay = new Ditto.Overlay(
        {
          tryOnServer: "https://vto.partners-au.api.ditto.com",
          partnerId: "projectsoul",
          domSelector: "#ditto-tryon",
          scanId: scanID,
          glassesId: get_id_send,
          overlaySignature: overlaySignature,
          accessKey: AccessKey
        },
        {
          initialized: function() {
            console.log("initialized");
          },
          success: function() {
//             let closeButton = document.getElementsByClassName("try-close");
// 	      	closeButton[0].style.display = "block";
        document.cookie = "vtoscanid="+scanID+"; max-age=" + 14*24*60*60 + "; path=/;";
		document.cookie = "vtooverlay="+overlaySignature+"; max-age=" + 1*60*60 + "; path=/;";
            
            let x = document.getElementsByClassName("left-content");
            x[0].style.display = "none";
            container.style.opacity = 0;
            container.style.visibility = "hidden";
            
            let y = document.getElementById("ditto-tryon");
            y.style.display = "block";
          },
          failure: function() {
            console.log("Failure");
            container.style.opacity = 0;
            container.style.visibility = "hidden";
          },
          onclick: function() {
            console.log("Optional Event: Click of VTO");
          }
        }
      );
    },
    failure: function(response) {
      console.log("failure", response);
      ga('send', 'event', 'Ditto', 'Success', 'IndexPage');
    },
    close: function(response) {
      console.log("close", response);
      container.style.opacity = 0;
      container.style.visibility = "hidden";
    }
  }
);
}

function getToken(){
  // Set up our HTTP request
  var xhr = new XMLHttpRequest();

  // Setup our listener to process completed requests
  xhr.onload = function () {

      // Process our return data
      if (xhr.status >= 200 && xhr.status < 300) {
			let response =JSON.parse(xhr.responseText);
        	signature = response["X-Ditto-Signature"];
	        checkVTO();
      } else {
			getToken();
      }
  };

  // Create and send a GET request
  // The first argument is the post type (GET, POST, PUT, DELETE, etc.)
  // The second argument is the endpoint URL
  xhr.open('GET', 'https://projectsouleyewear.com/tools/token');
  xhr.send();
}

function changeTryOnVariant(id_model){
  if(scanID != ""){
  	let scanContainer = document.getElementById("scan-iframe");
    if(scanContainer){
      scanContainer.style.display = "none";
    }
    

    var overlay = new Ditto.Overlay(
      {
        tryOnServer: "https://vto.partners-au.api.ditto.com",
        partnerId: "projectsoul",
        domSelector: "#ditto-tryon",
        scanId: scanID,
        glassesId: id_model,
        overlaySignature: overlaySignature,
        accessKey: AccessKey
      },
      {
        initialized: function() {
          console.log("initialized");
        },
        success: function() {
          //             let closeButton = document.getElementsByClassName("try-close");
          // 	      	closeButton[0].style.display = "block";
          console.log("Success");

		  let x = document.getElementsByClassName("left-content");
          x[0].style.display = "none";
//           container.style.opacity = 0;
//           container.style.visibility = "hidden";
          let y = document.getElementById("ditto-tryon");
          y.style.display = "block";
        },
        failure: function() {
          console.log("Failure");
//           container.style.opacity = 0;
//           container.style.visibility = "hidden";
        },
        onclick: function() {
          console.log("Optional Event: Click of VTO");
        }
      }
    );
  }
}

function retakeDitto(){
  let x = document.getElementsByClassName("left-content");
  x[0].style.display = "block";
  
  let container = document.getElementById("ditto-container");
  container.style.opacity = 1;
  container.style.visibility = "visible";

  let y = document.getElementById("ditto-tryon");
  y.style.display = "none";
  
  document.cookie = `vtoscanid=${scanID}; max-age=0; path=/;`;
  document.cookie = `vtooverlay=${overlaySignature}; max-age=0; path=/;`;
  getToken();
}